import React from "react";
import Welcome from "../../screens/auth/Welcome";
import type { Meta, StoryObj } from "@storybook/react";
import FirebaseManager, { FirebaseStatus } from "../../contexts/FirebaseManager";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { MockedProvider } from "@apollo/client/testing/react";
import { StoryStackNavigatorContainer } from "../display-helpers";

const StoryComponent = ({ isLogin }: { isLogin: string }) => {
    return (
        <MockedProvider mocks={[]}>
            <MockedAuthManager>
                <FirebaseManager
                    testContext={{
                        status: FirebaseStatus.Out,
                        user: undefined,
                        signOut: () => Promise.resolve(),
                    }}
                >
                    <StoryStackNavigatorContainer>
                        {/* @ts-expect-error Component need a complex navigation handler */}
                        <Welcome route={{ params: { isLogin } }} />
                    </StoryStackNavigatorContainer>
                </FirebaseManager>
            </MockedAuthManager>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Welcome",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        isLogin: "false",
    },
};
